import './css/styles.scss';

import './css/styles.scss';

// import Swiper JS
import Swiper from 'swiper';
// import Swiper and modules styles
import { Scrollbar, Mousewheel, FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initTjansterSwiper() {
    const swiper = new Swiper('.sliderspel-swiper', {
        modules: [Scrollbar, Mousewheel, FreeMode, Pagination],
        slidesPerView: 1.2, // Increase visibility of next slide
        spaceBetween: 20,
		centeredSlides: true,
        autoHeight: true,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
			1600: {
				slidesPerView: 3, // Allows right-side visibility
				spaceBetween: 25,
				freeMode: true,
				centeredSlides: false, // Disable centering to avoid cut-off
			},
            1200: {
                slidesPerView: 2, // Allows right-side visibility
                spaceBetween: 25,
                freeMode: true,
                centeredSlides: false, // Disable centering to avoid cut-off
            },
            640: {
                slidesPerView: 2.5,
                spaceBetween: 25,
                freeMode: true,
                centeredSlides: true,
            },
        },
    });

    swiper.slideToLoop(1, 0);
}

// Ensure it runs when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    initTjansterSwiper();
});

